import React, { useState, useRef, useLayoutEffect, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Chartjs from 'chart.js';
import ViewsContext from 'contexts/viewsContext';
import AppContext from 'contexts/appContext';
import Popup from 'components/common/popup/popup';
import SetChartGlobals, { HourlySalesChartThemeVars } from '../baseGlances/setGlobals';
import ChartConfig from '../baseGlances/chartConfig';
import { InitBarChartOptions } from '../baseGlances/initChartOptions';

function DefineChartData(data) {
  const { viewsState } = useContext(ViewsContext);

  SetChartGlobals();
  var calculatedData = HourlySalesChartThemeVars(calculatedData);;
  var dimention = viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.allDimentions.find((p) =>
    p.title === viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.activeDimention);
  for (var i = 0; i < data.length; i++) {
    calculatedData.labels.push(data[i].HOUR_STR)
    calculatedData.datasets[0].data.push(data[i][dimention.showVar]);
  }

  return calculatedData;
}

export default function HourlySalesChartGlance(props) {
  const getChartOptions = () => {
    var dimention = viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.allDimentions.find((p) =>
      p.title === viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.activeDimention);
    var label = t(dimention.title) + ' (' + dimention.sign + ')';
    var dollarFormat = dimention.dollarFormat;
    return { 'dollarFormat': dollarFormat, 'yAxis': label }
  }
  const { t } = useTranslation();
  const chartContainer = useRef(null);
  const [chartInstance, setChartInstance] = useState(null);
  const { viewsState, setHourlySalesBarChartConfig } = useContext(ViewsContext);
  const { appState } = useContext(AppContext);
  const options = InitBarChartOptions(getChartOptions());
  const data = DefineChartData(props.data);
  const [configureChartsPopupVisible, setConfigureChartsPopupVisible] = useState(false);

  function showTableView() {
    props.changeViewStateFn();
  }

  useLayoutEffect(() => {
    if (chartInstance != null) {
      chartInstance.options = options;
      chartInstance.data = data;
      chartInstance.update();
    }
  }, [viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.activeDimention]);

  useEffect(() => {

    const chartConfig = {
      type: 'bar',
      data: data,
      options: options
    };
    if (chartContainer && chartContainer.current) {
      const newChartInstance = new Chartjs(chartContainer.current, chartConfig);
      setChartInstance(newChartInstance);
    }
  }, [chartContainer]);

  const setDimention = (dimention) => {
    setHourlySalesBarChartConfig(dimention)
  };

  return (
    <>
      <div className={'panel panel-default glance glance-2x2 togglable togglable-chart glance-chart-holder sales-bar-chart-body ' + props.viewState} >
        <div className='panel-heading sales-bar-chart-heading' >
          <div className='edge edge-left'><i className='icons8-clock' aria-hidden='true' /></div>
          <div style={{ width: '80%' }}><h3 className='panel-title'>{t('HourlySales')}</h3></div>
          <div className='edge edge-right'><button type='button' className='btn btn-simple btn-left sales-bar-chart-btn' onClick={() => setConfigureChartsPopupVisible(true)} ><i className='icons8-settings' aria-hidden='true' /></button></div>
        </div>
        <div className='panel-body '>
          <div style={{ position: 'absolute', inset: '0px', overflow: 'hidden', pointerEvents: 'none', visibility: 'hidden', zIndex: '-1' }} className='chartjs-size-monitor'>
            <div className='chartjs-size-monitor-expand' style={{ position: 'absolute', left: '0', top: '0', right: '0', bottom: '0', overflow: 'hidden', pointerEvents: 'none', visibility: 'hidden', zIndex: '-1' }}>
              <div style={{ position: 'absolute', width: '1000000px', height: '1000000px', left: '0', top: '0' }}></div>
            </div>
            <div className='chartjs-size-monitor-shrink' style={{ position: 'absolute', left: '0', top: '0', right: '0', bottom: '0', overflow: 'hidden', pointerEvents: 'none', visibility: 'hidden', zIndex: '-1' }}>
              <div style={{ position: 'absolute', width: '200%', height: '200%', left: '0', top: '0' }}></div>
            </div>
          </div>
          <canvas ref={chartContainer} className='glance-chart chartjs-render-monitor' height='220' width='220' style={{ maxHeight: '220px' }}></canvas>
        </div>
        <div className='panel-footer '>
          <button className='btn btn-simple btn-default btn-block btn-large sales-bar-chart-btn' onClick={showTableView}>
            <i className='icons8-grid' />{t('ShowTable')}
          </button>
        </div>
      </div>
      <Popup title={t('ConfigureChart')} theme={appState.theme} size='md' show={configureChartsPopupVisible} onClose={() => setConfigureChartsPopupVisible(false)}>
        <ChartConfig chartDimentions={viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.allDimentions} activeDimention={viewsState.chartsAndTableViewsConfigs.hourlySalesBarChart.activeDimention} setDimention={setDimention} />
      </Popup>
    </>
  );
}